var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"title":"查看可评审专业","visible":_vm.visible,"width":"50%","top":"6vh","close-on-click-modal":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('el-tree',{attrs:{"data":_vm.speTree}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }